// Rutas de la APLICACIÓN (panel, app de familias y sus flujos), frente a la
// ruta pública (la landing y sus páginas).
//
// Es la misma lista que `vercel.json` reescribe a `app.html`, y tiene que
// seguir siéndolo: lo sostiene src/test/landing-ligera.test.ts. LDT-717 la usa
// para que lo que la ruta pública pinta fuera de `.playium-landing` (el banner
// de cookies, la 404) vaya con la tipografía de marca sin tocar el panel.
export const APP_PATH_PREFIXES = [
  "/platform",
  "/app",
  "/calendar",
  "/legal",
  "/reset-password",
  "/unsubscribe",
  "/subscribe",
] as const;

/** Prefijos que también son app a secas, sin nada detrás. El resto
 *  (`/app`, `/calendar`, `/legal`, `/subscribe`) solo lo son con subruta, como
 *  sus reescrituras `/x/(.*)` de vercel.json: `/legal` a secas es la portada
 *  legal pública (LDT-700), no la app. */
const EXACT_APP_PATHS: readonly string[] = ["/platform", "/reset-password", "/unsubscribe"];

/** ¿Es `pathname` una ruta de la aplicación (y no de la landing)?
 *  LDT-718 · Decide qué árbol la pinta: App.tsx (landing) o Plataforma.tsx. */
export function isAppPath(pathname: string): boolean {
  // Con barra final es la misma página: Vercel sirve `/legal/` desde
  // legal/index.html, igual que `/legal`.
  const path = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
  if (EXACT_APP_PATHS.includes(path)) return true;
  return APP_PATH_PREFIXES.some((p) => path.startsWith(`${p}/`));
}
